import { makeStyles } from '@material-ui/styles'

const checkboxRadius = 30
const checkboxDiameter = checkboxRadius * 2

export const useStyles = makeStyles(({ typographyPresets, colors }) => ({
    widget: {
        backgroundImage: 'linear-gradient(to bottom, #1f2533, #0e1117)',
        height: '100%',
        maxHeight: 630,
        padding: '20px 20px 24px 20px',
    },
    tabs: {
        marginBottom: 20,
    },
    list: {
        overflow: 'auto',
        height: '100%',
    },
    question: {
        display: 'flex',
        alignItems: 'center',
    },
    forumPostWrapper: {
        padding: '0 4px 0 15px',
        marginRight: '20px',
        width: `calc(100% - ${checkboxDiameter}px)`,
    },
    checkbox: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${checkboxDiameter}px`,
        height: `${checkboxDiameter}px`,
        borderRadius: `${checkboxRadius}px`,
        backgroundColor: colors.dark.dark4,
        color: colors.light.darkgrey,
    },
    noQuestions: {
        ...typographyPresets.bodySecondary,
        color: colors.white,
        padding: '20px',
    },
}))
